import React from 'react';
import { FaCheck, FaHourglassHalf, FaFileAlt, FaTimesCircle } from 'react-icons/fa';
import { StatCard } from './UnifiedUIComponents';

// Row of clickable summary cards that filter the list below them.
//   groups: [{ key, title, icon, color, match(record) }]  — a leading "Total" card is added.
//   records: the unfiltered list (counts ignore other filters so numbers stay stable).
//   value / onChange: the selected group key ('All' = none). Clicking the active card clears it.
// The page applies the filter itself with `matchesGroup(groups, value, record)`.
export const matchesGroup = (groups, value, record) => {
  if (!value || value === 'All') return true;
  const group = groups.find((g) => g.key === value);
  return group ? !!group.match(record) : true;
};

// Standard approval-workflow groups (Draft / Pending* / Approved / Rejected) keyed off record.status.
export const approvalStatusGroups = [
  { key: 'approved', title: 'Approved', icon: FaCheck, color: 'success', match: (r) => r.status === 'Approved' },
  { key: 'pending', title: 'Pending Approval', icon: FaHourglassHalf, color: 'warning', match: (r) => /^Pending/i.test(r.status || '') },
  { key: 'draft', title: 'Draft', icon: FaFileAlt, color: 'info', match: (r) => !r.status || r.status === 'Draft' },
  { key: 'rejected', title: 'Rejected', icon: FaTimesCircle, color: 'danger', match: (r) => r.status === 'Rejected' },
];

export default function FilterStatCards({ groups, records = [], value = 'All', onChange, totalTitle = 'Total', totalIcon, totalColor = 'primary' }) {
  const select = (key) => onChange(key === 'All' || value === key ? 'All' : key);
  return (
    <div className="stat-card-grid">
      <StatCard
        compact filterHint title={totalTitle} value={records.length} icon={totalIcon} color={totalColor}
        active={!value || value === 'All'} onClick={() => select('All')}
      />
      {groups.map((g) => (
        <StatCard
          key={g.key} compact filterHint title={g.title} icon={g.icon} color={g.color || 'primary'}
          value={records.filter(g.match).length}
          active={value === g.key} onClick={() => select(g.key)}
        />
      ))}
    </div>
  );
}
